"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const line_1 = require("@nivo/line");
const chart_style_1 = __importDefault(require("../chart.style"));
const LineChart = ({ data, appTheme, colors, title, tooltip, tickValues, dashboardMode }) => {
    let xScale = {
        min: 'auto',
        max: 'auto',
        useUTC: false,
        type: 'time',
        format: '%Y-%m-%d',
        precision: dashboardMode === 'months' ? 'month' : 'day',
    };
    if (dashboardMode === 'weeks')
        xScale = {
            type: 'point',
        };
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: chart_style_1.default.LineChartContainer(appTheme) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { height: 'calc(100vh - 491px)', minHeight: '435px' } }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: title }), (0, jsx_runtime_1.jsx)(line_1.ResponsiveLine, { data: data, lineWidth: 4, colors: colors ? colors : { scheme: 'paired' }, margin: { bottom: 70, left: 40, top: 50, right: 30 }, xScale: xScale, xFormat: dashboardMode === 'weeks' ? '' : 'time:%Y-%m-%d', yScale: {
                        min: 'auto',
                        max: 'auto',
                        type: 'linear',
                        stacked: false,
                        reverse: false
                    }, yFormat: ' >-.2f', axisTop: null, axisRight: null, axisBottom: {
                        tickSize: 5,
                        format: dashboardMode === 'months' ? '%b %y' : dashboardMode === 'days' ? '%b %d' : '',
                        tickPadding: 5,
                        tickRotation: 0,
                        legendOffset: 36,
                        legendPosition: 'middle',
                        tickValues: dashboardMode === 'months' ? 'every 1 month' :
                            dashboardMode === 'weeks' ? tickValues : 'every 1 days'
                    }, axisLeft: {
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: '',
                        legendOffset: 0,
                        legendPosition: 'middle',
                    }, enableGridY: false, pointSize: 9, pointColor: { from: 'color', modifiers: [] }, pointBorderWidth: 2, pointBorderColor: { from: 'color', modifiers: [] }, pointLabel: 'y', pointLabelYOffset: -12, areaBaselineValue: 10, areaOpacity: 0, useMesh: true, theme: chart_style_1.default.LineChartStyle(appTheme), tooltip: tooltip, legends: [
                        {
                            anchor: 'top-left',
                            direction: 'row',
                            justify: false,
                            translateX: -35,
                            translateY: -40,
                            itemWidth: 90,
                            itemHeight: 0,
                            itemsSpacing: 24,
                            symbolSize: 20,
                            symbolShape: 'square',
                            itemDirection: 'left-to-right',
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemBackground: 'rgba(0, 0, 0, .03)',
                                        itemOpacity: 1,
                                    },
                                },
                            ],
                        },
                    ] }, Math.random())] })) })));
};
exports.default = LineChart;
